import { render } from "./CommunityList.vue?vue&type=template&id=4af5e994"
import script from "./CommunityList.vue?vue&type=script&lang=js"
export * from "./CommunityList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__